import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Btn, H4, P } from '../../../AbstractElements';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { forgotPassword, resetPassword } from '../../../api-handle/authApi';

const ForgetPwd = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isStrongPassword = (password) =>
    password.length >= 8 && /[A-Z]/.test(password) && /\d/.test(password);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      toast.error('Invalid email format');
      return;
    }
    try {
      await forgotPassword({ email });
      toast.success('OTP sent to your email!');
      setStep(2);
    } catch (err) {
      toast.error(err.message || 'Failed to send OTP.');
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword({ email });
      toast.success('OTP resent!');
    } catch (err) {
      toast.error(err.message || 'Failed to resend OTP.');
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!otp || !password) {
      toast.error('Please fill all fields.');
      return;
    }

    if (!isStrongPassword(password)) {
      toast.error('Password must be at least 8 characters long, include an uppercase letter and a number.');
      return;
    }

    try {
      await resetPassword({ email, otp, newPassword: password });
      toast.success('Password reset successfully!');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      toast.error(err.message || 'Failed to reset password.');
    }
  };

  return (
    <Container className='p-0 login-page' fluid>
      <Row className='m-0'>
        <Col className='p-0'>
          <div className='login-card'>
            <div className='login-main'>
              <Form className='theme-form login-form'>
                <H4>Reset Your Password</H4>

                {step === 1 && (
                  <>
                    <FormGroup>
                      <Label>Enter Your Email</Label>
                      <Input
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder='xyz@mail.com'
                      />
                    </FormGroup>
                    <FormGroup>
                      <Btn attrBtn={{ color: 'primary', className: 'w-100', type: 'button', onClick: handleSendOtp }}>
                        Send OTP
                      </Btn>
                    </FormGroup>
                  </>
                )}

                {step === 2 && (
                  <>
                    <FormGroup>
                      <Label>Enter OTP</Label>
                      <Input
                        type='text'
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder='Enter OTP'
                      />
                      <span className="btn-link text-primary mt-2 d-block" onClick={handleResendOtp}>
                        Resend OTP
                      </span>
                    </FormGroup>
                    <FormGroup>
                      <Label>New Password</Label>
                      <div className='position-relative'>
                        <Input
                          type={togglePassword ? 'text' : 'password'}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder='********'
                        />
                        <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                          <span className={togglePassword ? '' : 'show'}></span>
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Btn attrBtn={{ color: 'primary', className: 'w-100', type: 'button', onClick: handleResetPassword }}>
                        Reset Password
                      </Btn>
                    </FormGroup>
                  </>
                )}
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPwd;
